var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTax1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_12770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9617 19.8198V9.95963M6.46115 30.2015V2.31082C6.46115 1.43958 7.1683 0.732422 8.03955 0.732422H41.3833C42.2546 0.732422 42.9617 1.43958 42.9617 2.31082V6.54106M6.46115 42.3618V33.62M42.9617 38.072V45.5186C42.9617 47.5893 41.2827 49.2673 39.213 49.2673M5.67244 49.2673C3.60215 49.2673 1.92383 47.589 1.92383 45.5187V43.3484C1.92383 42.8036 2.36551 42.3619 2.91033 42.3619H34.4777C35.0225 42.3619 35.4642 42.8036 35.4642 43.3484V45.5187C35.4642 47.589 37.1425 49.2673 39.2128 49.2673H5.67244Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9559 20.2642H18.003M25.9559 23.4209H18.003M21.7924 9.41284L23.5705 4.74445C23.6068 4.65566 23.7325 4.65547 23.7691 4.74425L25.5309 9.41284M22.3469 8.25014H24.9854M28.7626 4.67773L32.0936 9.41284M31.8592 4.67773L28.5234 9.41284M17.3286 4.67773H19.9436M18.6308 4.82893V9.41284M25.9559 27.3668H18.003M25.9559 30.5236H18.003M25.9559 34.4695H18.003M25.9559 37.6262H18.003M48.0393 33.3528C48.7035 32.0264 49.0766 30.5291 49.0766 28.9448C49.0766 23.4966 44.6608 19.0808 39.2126 19.0808C33.7644 19.0808 29.3476 23.4966 29.3476 28.9448C29.3476 34.393 33.7644 38.8098 39.2126 38.8098C41.8488 38.8098 44.2437 37.7754 46.0136 36.0906M13.1692 16.3183H36.2529C36.4622 16.3183 36.6629 16.2351 36.8109 16.0871C36.9589 15.9391 37.0421 15.7384 37.0421 15.5291V14.148C37.0421 13.9386 36.9589 13.7379 36.8109 13.5899C36.6629 13.4419 36.4622 13.3588 36.2529 13.3588H13.1692C12.9599 13.3588 12.7592 13.4419 12.6112 13.5899C12.4632 13.7379 12.38 13.9386 12.38 14.148V15.5291C12.38 15.6327 12.4005 15.7353 12.4401 15.8311C12.4798 15.9268 12.5379 16.0138 12.6112 16.0871C12.6845 16.1604 12.7715 16.2185 12.8672 16.2582C12.963 16.2978 13.0656 16.3183 13.1692 16.3183ZM10.9004 20.2642H14.0571V23.4209H10.9004V20.2642ZM10.9004 27.3668H14.0571V30.5235H10.9004V27.3668ZM10.9004 34.4695H14.0571V37.6262H10.9004V34.4695Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2128 23.5195C36.221 23.5195 33.7871 25.9535 33.7871 28.9452C33.7871 31.9369 36.221 34.3709 39.2128 34.3709C42.2045 34.3709 44.6384 31.9369 44.6384 28.9452V27.925",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0199 28.8525L44.6388 27.5547L43.2578 28.8525",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_12770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax1);
export default __webpack_public_path__ + "static/media/tax 1.3981e3ae500e0759d2b6747a6646d9f4.svg";
export { ForwardRef as ReactComponent };